import React, { useState, useEffect } from "react";
import axios from "../../services/api";

const ItemForm = ({ fetchItems, editItem, closeModal }) => {
  const [item, setItem] = useState({ name: "", category: "", unit: "" });
  const [items, setItems] = useState([]); 
  const [error, setError] = useState("");

  useEffect(() => {
    if (editItem) {
      setItem(editItem);
    }
    fetchExistingItems();
  }, [editItem]);

  const fetchExistingItems = async () => {
    try {
        const response = await axios.get("/items");
        console.log("API Response:", response.data); // Debugging

        // Ensure items is always an array
        setItems(Array.isArray(response.data.items) ? response.data.items : []);
    } catch (error) {
        console.error("Error fetching items:", error);
        setItems([]); // Avoid further errors by setting an empty array
    }
};



  const handleChange = (e) => {
    setItem({ ...item, [e.target.name]: e.target.value });
    setError(""); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure items is an array before using find()
    if (!Array.isArray(items)) {
        console.error("Error: 'items' is not an array", items);
        setError("Something went wrong. Please refresh and try again.");
        return;
    }

    // Ensure item.name is defined before calling toLowerCase()
    if (!item?.name) {
        setError("Item name is required!");
        return;
    }

    // Check for duplicate item name (case insensitive)
    const duplicate = items.find((existingItem) =>
        existingItem?.name?.toLowerCase() === item.name.toLowerCase()
    );

    if (!editItem && duplicate) {
        setError("Item name already exists!");
        return;
    }

    try {
        if (editItem) {
            await axios.put(`/items/${editItem.id}`, item);
            alert('Item Updated Successfully')
        } else {
            await axios.post("/items", item);
            alert('Item Added Successfully')
        }
        fetchItems();
        closeModal();
        setItem({ name: "", category: "", unit: "" }); // Reset form
        
    } catch (error) {
        console.error("Error saving item:", error.response?.data || error);
        setError("Failed to save item. Please try again.");
    }
};


  return (
    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{editItem ? "Edit Item" : "Add Item"}</h5>
            <button type="button" className="close text-white" onClick={closeModal}>&times;</button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Item Name</label>
                <input
                  type="text"
                  name="name"
                  className={`form-control ${error ? "is-invalid" : ""}`}
                  value={item.name}
                  onChange={handleChange}
                  required
                />
                {error && <div className="invalid-feedback">{error}</div>}
              </div>
              <div className="form-group mb-3">
                <label>Category</label>
                <input type="text" name="category" className="form-control" value={item.category} onChange={handleChange} required />
              </div>
             
              <div className="form-group mb-3">
                <label>Unit (e.g., kg, pcs)</label>
                <input type="text" name="unit" className="form-control" value={item.unit} onChange={handleChange} required />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>Cancel</button>
                <button type="submit" className="btn btn-success">{editItem ? "Update Item" : "Add Item"}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemForm;
